import { render, staticRenderFns } from "./PageForHome.vue?vue&type=template&id=ed61d748&scoped=true&"
import script from "./PageForHome.vue?vue&type=script&lang=js&"
export * from "./PageForHome.vue?vue&type=script&lang=js&"
import style0 from "./PageForHome.vue?vue&type=style&index=0&id=ed61d748&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed61d748",
  null
  
)

export default component.exports